<template>
  <div class="sm:px-0 flex items-center justify-center md:px-5 px-3 py-2.5">
    <div class="flex items-center space-x-2.5">
      <button
        :name="locale === 'hy' ? 'Նախորդ էջ' : 'Previous page'"
        :aria-label="locale === 'hy' ? 'Նախորդ էջ' : 'Previous page'"
        :disabled="prevDisabled"
        @click="$emit('prev')"
        type="button"
        :class="
          prevDisabled ? 'cursor-not-allowed' : 'text-blue-600 cursor-pointer'
        "
        class="size-8 min-w-8 rounded-full text-base flex items-center justify-center hover:bg-primary/5 transition-all duration-300"
      >
        <Icon name="ph:arrow-left" size="18" />
      </button>
      <button
        :aria-label="locale === 'hy' ? 'Տեսնել ավելին' : 'More pages'"
        :name="locale === 'hy' ? 'Տեսնել ավելին' : 'More pages'"
        class="size-8 min-w-8 rounded-full text-base flex items-center justify-center hover:bg-primary/5 transition-all duration-300"
        :class="
          currentPage === item
            ? 'text-blue-600 cursor-not-allowed bg-primary-blue/10'
            : 'cursor-pointer'
        "
        :disabled="loading"
        @click="$emit('change-page', item)"
        type="button"
        v-for="item in visiblePages"
        :key="item"
      >
        <Icon name="ph:dots-three" v-if="item === '…'" size="24" />
        <span v-else>{{ item }}</span>
      </button>
      <button
        :name="locale === 'hy' ? 'Հաջորդ' : 'Next page'"
        :aria-label="locale === 'hy' ? 'Հաջորդ' : 'Next page'"
        :disabled="nextDisabled"
        @click="$emit('next')"
        type="button"
        :class="
          nextDisabled ? 'cursor-not-allowed' : 'text-blue-600 cursor-pointer'
        "
        class="size-8 min-w-8 rounded-full text-base flex items-center justify-center hover:bg-primary/5 transition-all duration-300"
      >
        <Icon name="ph:arrow-right" size="18" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useWindowSize } from "@vueuse/core";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const { width } = useWindowSize();

const emit = defineEmits(["prev", "next", "change-page"]);

const props = defineProps<{
  loading?: boolean;
  totalPages: number;
  currentPage: number;
}>();

const visiblePages = computed(() => {
  const total = props.totalPages;
  const current = props.currentPage;
  const delta = width.value > 500 ? 5 : 1;
  const pages = [];

  for (let i = 1; i <= total; i++) {
    if (
      i === 1 ||
      i === total ||
      (i >= current - delta && i <= current + delta)
    ) {
      pages.push(i);
    }
  }

  const result: (number | string)[] = [];
  let prev: number | null = null;
  for (const page of pages) {
    if (prev && page - prev > 1) result.push("…");
    result.push(page);
    prev = page;
  }
  return result;
});

const nextDisabled = computed<boolean>(
  () => props.currentPage >= props.totalPages || props.loading,
);
const prevDisabled = computed<boolean>(
  () => props.currentPage < 2 || props.loading,
);
</script>
